import React from 'react';
import {
    FaUsers, FaChartBar, FaBullseye, FaComments, FaUser, FaFileAlt,
    FaCog, FaEdit, FaTrash, FaEye, FaHeart, FaComment, FaMoon, FaSun,
    FaDoorOpen, FaBars, FaTimes, FaSearch, FaPhone, FaFlag, FaLock,
    FaFootballBall, FaLaptop, FaPizzaSlice, FaPlane, FaBook, FaDumbbell,
    FaUserTie, FaExclamationTriangle, FaMale, FaFemale, FaRocket, FaBolt,
    FaCamera, FaMap, FaUtensils, FaCubes, FaPen, FaRunning, FaYinYang,
    FaWeightHanging, FaFistRaised, FaMobileAlt, FaRobot, FaShieldAlt, FaTools,
    FaBullhorn, FaLayerGroup
} from 'react-icons/fa';
import {
    MdDashboard, MdSportsTennis, MdSportsBasketball, MdSportsCricket,
    MdBackpack, MdLandscape, MdKayaking, MdMenuBook, MdNoteAlt
} from 'react-icons/md';
import { BsClipboardData } from 'react-icons/bs';
import { GiRaceCar, GiCricketBat, GiCupcake, GiBowlOfRice } from 'react-icons/gi';

export const renderIcon = (type, size = 16) => {
    // Define color schemes for different categories
    const colorSchemes = {
        // User avatars
        'male': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'female': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(245, 87, 108, 0.3)' },

        // Sports
        'football': { gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', shadow: 'rgba(56, 239, 125, 0.3)' },
        'cricket': { gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)', shadow: 'rgba(255, 106, 0, 0.3)' },
        'tennis': { gradient: 'linear-gradient(135deg, #f2994a 0%, #f2c94c 100%)', shadow: 'rgba(242, 201, 76, 0.3)' },
        'basketball': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(254, 225, 64, 0.3)' },
        'racecar': { gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', shadow: 'rgba(48, 207, 208, 0.3)' },

        // Tech
        'laptop': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'mobile': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'robot': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(0, 242, 254, 0.3)' },
        'rocket': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'bolt': { gradient: 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)', shadow: 'rgba(255, 216, 155, 0.3)' },

        // Food
        'pizza': { gradient: 'linear-gradient(135deg, #ff9a56 0%, #ff6a88 100%)', shadow: 'rgba(255, 154, 86, 0.3)' },
        'utensils': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },
        'rice': { gradient: 'linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)', shadow: 'rgba(253, 219, 146, 0.3)' },
        'cupcake': { gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', shadow: 'rgba(255, 154, 158, 0.3)' },
        'burger': { gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', shadow: 'rgba(252, 182, 159, 0.3)' },
        'noodles': { gradient: 'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)', shadow: 'rgba(255, 110, 127, 0.3)' },

        // Travel
        'plane': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'backpack': { gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', shadow: 'rgba(67, 233, 123, 0.3)' },
        'camera': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'landscape': { gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', shadow: 'rgba(48, 207, 208, 0.3)' },
        'map': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'kayak': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },

        // Books
        'book': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'menubook': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'pen': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'notebook': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },

        // Fitness
        'dumbbell': { gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)', shadow: 'rgba(238, 9, 121, 0.3)' },
        'running': { gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', shadow: 'rgba(56, 239, 125, 0.3)' },
        'yoga': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'weightlifting': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'gymnastics': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },
        'boxing': { gradient: 'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)', shadow: 'rgba(255, 110, 127, 0.3)' },

        // UI & Navigation
        'dashboard': { gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)', shadow: 'rgba(255, 107, 107, 0.3)' },
        'users_nav': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'groups_nav': { gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', shadow: 'rgba(67, 233, 123, 0.3)' },
        'chats': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'private_chats': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'posts_nav': { gradient: 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)', shadow: 'rgba(255, 216, 155, 0.3)' },
        'revenue': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'settings': { gradient: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)', shadow: 'rgba(137, 247, 254, 0.3)' },
        'activity': { gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)', shadow: 'rgba(246, 211, 101, 0.3)' },
        'shield': { gradient: 'linear-gradient(135deg, #ef4444 0%, #991b1b 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'tool': { gradient: 'linear-gradient(135deg, #2B7FD9 0%, #1e40af 100%)', shadow: 'rgba(43, 127, 217, 0.3)' },
        'megaphone': { gradient: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)', shadow: 'rgba(255, 107, 107, 0.3)' },
        'categories': { gradient: 'linear-gradient(135deg, #8B5CF6 0%, #6366F1 100%)', shadow: 'rgba(139, 92, 246, 0.3)' },
        'support': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)', shadow: 'rgba(245, 158, 11, 0.3)' }
    };

    const iconMap = {
        'male': <FaMale size={size} />,
        'female': <FaFemale size={size} />,
        'football': <FaFootballBall size={size} />,
        'laptop': <FaLaptop size={size} />,
        'pizza': <FaPizzaSlice size={size} />,
        'plane': <FaPlane size={size} />,
        'book': <FaBook size={size} />,
        'dumbbell': <FaDumbbell size={size} />,
        'racecar': <GiRaceCar size={size} />,
        'cricket': <GiCricketBat size={size} />,
        'tennis': <MdSportsTennis size={size} />,
        'basketball': <MdSportsBasketball size={size} />,
        'mobile': <FaMobileAlt size={size} />,
        'robot': <FaRobot size={size} />,
        'rocket': <FaRocket size={size} />,
        'bolt': <FaBolt size={size} />,
        'utensils': <FaUtensils size={size} />,
        'rice': <GiBowlOfRice size={size} />,
        'cupcake': <GiCupcake size={size} />,
        'burger': <FaUtensils size={size} />,
        'noodles': <FaUtensils size={size} />,
        'backpack': <MdBackpack size={size} />,
        'camera': <FaCamera size={size} />,
        'landscape': <MdLandscape size={size} />,
        'map': <FaMap size={size} />,
        'kayak': <MdKayaking size={size} />,
        'menubook': <MdMenuBook size={size} />,
        'pen': <FaPen size={size} />,
        'notebook': <MdNoteAlt size={size} />,
        'running': <FaRunning size={size} />,
        'yoga': <FaYinYang size={size} />,
        'weightlifting': <FaWeightHanging size={size} />,
        'gymnastics': <FaRunning size={size} />,
        'boxing': <FaFistRaised size={size} />,
        'dashboard': <MdDashboard size={size} />,
        'users_nav': <FaUsers size={size} />,
        'groups_nav': <FaBullseye size={size} />,
        'chats': <FaComments size={size} />,
        'private_chats': <FaUser size={size} />,
        'posts_nav': <FaFileAlt size={size} />,
        'revenue': <FaChartBar size={size} />,
        'settings': <FaCog size={size} />,
        'activity': <BsClipboardData size={size} />,
        'shield': <FaShieldAlt size={size} />,
        'tool': <FaTools size={size} />,
        'megaphone': <FaBullhorn size={size} />,
        'categories': <FaLayerGroup size={size} />,
        'support': <FaExclamationTriangle size={size} />
    };

    const icon = iconMap[type] || <FaUser size={size} />;
    const colors = colorSchemes[type] || { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' };

    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: colors.gradient.match(/#[0-9a-fA-F]{6}/) ? colors.gradient.match(/#[0-9a-fA-F]{6}/)[0] : '#667eea',
            background: colors.gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            filter: `drop-shadow(0 1px 2px ${colors.shadow})`
        }}>
            {icon}
        </span>
    );
};
